import { render, staticRenderFns } from "./items-type-repair.vue?vue&type=template&id=31b1d763&scoped=true&"
import script from "./items-type-repair.vue?vue&type=script&lang=js&"
export * from "./items-type-repair.vue?vue&type=script&lang=js&"
import style0 from "./items-type-repair.vue?vue&type=style&index=0&id=31b1d763&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b1d763",
  null
  
)

export default component.exports